import React from "react";
import { Link } from "react-router-dom";
import { IMGS, waLink } from "../lib/api";
import { WhyUs } from "../components/home/WhyUs";
import { useSEO } from "../lib/seo";

export default function AboutPage() {
  useSEO({
    title: "About Us — Authentic Ilkal Sarees from Ilkal, Karnataka | R V Ilkal Sarees",
    description: "R V Ilkal Sarees brings original handloom and powerloom Ilkal sarees from Ilkal city, Karnataka to customers across India and the world. Founded by Raghu and Vishwa.",
    canonicalPath: "/about",
  });
  return (
    <main data-testid="about-page">
      <section className="py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <p className="uppercase tracking-[0.25em] text-xs font-semibold text-gold">About R V Ilkal Sarees</p>
            <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-charcoal mt-3 leading-tight" data-testid="about-heading">
              WOVEN IN ILKAL. ROOTED IN TRADITION.
            </h1>
            <p className="text-base leading-relaxed text-charcoal/70 mt-6">
              Mechanical Engineer Raghu and Nursing Officer Vishwa — two people diametrically opposite in profession but surprisingly synchronised in passion — came together, and R V ILKAL SAREES was born.
            </p>
            <p className="text-base leading-relaxed text-charcoal/70 mt-4">
              At R V Ilkal Sarees, we connect you to the roots — India's heritage — through the most beautiful handloom and powerloom woven Ilkal sarees, straight from Ilkal city, Karnataka.
            </p>
            <p className="text-base leading-relaxed text-charcoal/70 mt-4">
              RV Ilkal Sarees is about bringing the world a little closer to the real beauty of India. We discover the best designs from artisans and craftsmen all over India, and deliver them at your doorstep no matter where you are sitting — Mumbai or USA, UK or Australia, Canada or Dubai, or anywhere in the world!
            </p>
            <div className="flex flex-wrap gap-4 mt-8">
              <Link to="/shop" data-testid="about-shop-btn" className="bg-maroon text-ivory px-8 py-3.5 text-xs tracking-[0.2em] uppercase hover:bg-maroon-dark transition-colors">
                Shop the Collection
              </Link>
              <a
                href={waLink("Namaste! I'd love to know more about R V Ilkal Sarees.")}
                target="_blank"
                rel="noreferrer"
                data-testid="about-whatsapp-btn"
                className="border border-gold text-charcoal px-8 py-3.5 text-xs tracking-[0.2em] uppercase hover:bg-gold/10 transition-colors"
              >
                Talk to Us
              </a>
            </div>
          </div>
          <div className="relative">
            <div className="aspect-[4/5] overflow-hidden">
              <img src={IMGS.weave} alt="Traditional handloom weaving in Ilkal" className="w-full h-full object-cover" />
            </div>
            <div className="absolute -bottom-8 -left-4 sm:-left-8 w-40 sm:w-56 aspect-square overflow-hidden border-4 border-ivory shadow-xl">
              <img src={IMGS.texture} alt="Close-up of Ilkal weave texture" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </section>
      <WhyUs />
    </main>
  );
}
